import { ACTIVITY_LABELS } from "./activityLabels"

// The vocabulary of the activity events activity/ sends (`event_type`). The events themselves
// are read by the backend off its own tables — status transitions, evidence versions and
// submissions — so only types it can actually record are here: there is no enrichment score and
// no assignee yet, so no "enriched" or "assigned" either.

// Details are the second line: the activity stream hangs them off an info icon. They explain the
// event, they do not repeat it.
export const EVENT_DETAILS = {
  received: "Scheduled for automatic submission unless one of your rules holds it.",
  generated: "The evidence package was assembled from the enriched fields.",
  regenerated: "The package was rebuilt after the enrichment changed.",
  approved: "A team member reviewed the evidence and sent it.",
  submitted_auto: "No rule held it back, so it was submitted on schedule.",
  review: "One of your rules applies, so it will not be submitted automatically.",
  pending: "Evidence is with the issuer. Awaiting their decision.",
  escalated: "The inquiry was not resolved, so the issuer is turning it into a dispute.",
  won: "The issuer ruled in your favour.",
  lost: "The issuer ruled against you.",
  not_fought: "No evidence was submitted, by rule or by choice."
}

// Every event type, in the order the events happen. Drives the "What changed" filter, so
// its order is the order of that dropdown.
const DISPUTE_EVENT_ORDER = [
  "created",
  "received",
  "generated",
  "regenerated",
  "approved",
  "submitted_auto",
  "review",
  "pending",
  "escalated",
  "won",
  "lost",
  "not_fought"
]

// Filter-option wording. Most types read fine as their own label, but one names a person
// ("Approved and submitted by Mia Chen") and cannot be a filter option, so it gets a generic form.
const FILTER_LABEL_OVERRIDES = {
  approved: "Approved and submitted by a team member"
}

export const DISPUTE_EVENT_FILTER_DATA = DISPUTE_EVENT_ORDER.map((id) => ({
  id,
  name: FILTER_LABEL_OVERRIDES[id] || ACTIVITY_LABELS[id] || id
}))
